import {
    POST_TYPE_IDS_ENUM as _POST_TYPE_IDS_ENUM,
    // @ts-ignore
} from "@my-scoot/exly-react-component-lib/build/cjs/constants/BrandedCommunity/Post";
import {
    EXLY_COMMUNITY_FEED_TYPES as _EXLY_COMMUNITY_FEED_TYPES,
    EXLY_COMMUNITY_CHANNEL_TYPES as _EXLY_COMMUNITY_CHANNEL_TYPES,
    // @ts-ignore
} from "@my-scoot/exly-react-component-lib/build/cjs/constants/BrandedCommunity/Miscellaneous";
import {
    POSTS_TABS_KEYS as _POSTS_TABS_KEYS,
    POSTS_TABS_LIST as _POSTS_TABS_LIST,
    // @ts-ignore
} from "@my-scoot/exly-react-component-lib/build/cjs/constants/BrandedCommunity/PostsListContainer";
import type { POST_TYPE_IDS_ENUM as POST_TYPE_IDS_ENUM_TYPE } from "@my-scoot/exly-react-component-lib/build/types/constants/BrandedCommunity/Post";
import type {
    POSTS_TABS_KEYS as POSTS_TABS_KEYS_TYPE,
    POSTS_TABS_LIST as POSTS_TABS_LIST_TYPE,
} from "@my-scoot/exly-react-component-lib/build/types/constants/BrandedCommunity/PostsListContainer";
import type {
    EXLY_COMMUNITY_FEED_TYPES as EXLY_COMMUNITY_FEED_TYPES_TYPE,
    EXLY_COMMUNITY_CHANNEL_TYPES as EXLY_COMMUNITY_CHANNEL_TYPES_TYPE,
} from "@my-scoot/exly-react-component-lib/build/types/constants/BrandedCommunity/Miscellaneous";
import {
    BRANDED_COMMUNITY_REPORTING_API_KEYS as _BRANDED_COMMUNITY_REPORTING_API_KEYS,
    BRANDED_COMMUNITY_REPORT_CONTENT_TYPES as _BRANDED_COMMUNITY_REPORT_CONTENT_TYPES,
    BRANDED_COMMUNITY_APIS as _BRANDED_COMMUNITY_APIS,
    BRANDED_COMMUNITY_POST_CREATION_KEYS as _BRANDED_COMMUNITY_POST_CREATION_KEYS,
    CHANGE_STATES as _CHANGE_STATES,
    POST_SHARING_TYPES as _POST_SHARING_TYPES,
    // @ts-ignore
} from "@my-scoot/exly-react-component-lib/build/cjs/features/BrandedCommunity/constants/BrandedCommunity.constants";
import { COMMUNITY_URL_QUERY_PARAMS as _COMMUNITY_URL_QUERY_PARAMS } from "repoV2/features/BrandedCommunity/BrandedCommunity.constants";
import {
    BRANDED_COMMUNITY_REPORTING_API_KEYS as BRANDED_COMMUNITY_REPORTING_API_KEYS_TYPE,
    BRANDED_COMMUNITY_REPORT_CONTENT_TYPES as BRANDED_COMMUNITY_REPORT_CONTENT_TYPES_TYPE,
    BRANDED_COMMUNITY_APIS as BRANDED_COMMUNITY_APIS_TYPE,
    BRANDED_COMMUNITY_POST_CREATION_KEYS as BRANDED_COMMUNITY_POST_CREATION_KEYS_TYPE,
    CHANGE_STATES as CHANGE_STATES_TYPE,
    POST_SHARING_TYPES as POST_SHARING_TYPES_TYPE,
} from "@my-scoot/exly-react-component-lib/build/types/features/BrandedCommunity/constants/BrandedCommunity.constants";
import { IBrandedCommunity } from "../IBrandedCommunity";

export const POSTS_TABS_LIST: typeof POSTS_TABS_LIST_TYPE = _POSTS_TABS_LIST;

export const POST_TYPE_IDS_ENUM: typeof POST_TYPE_IDS_ENUM_TYPE =
    _POST_TYPE_IDS_ENUM;

export const POSTS_TABS_KEYS: typeof POSTS_TABS_KEYS_TYPE = _POSTS_TABS_KEYS;

export const BRANDED_COMMUNITY_REPORTING_API_KEYS: typeof BRANDED_COMMUNITY_REPORTING_API_KEYS_TYPE =
    _BRANDED_COMMUNITY_REPORTING_API_KEYS;

export const BRANDED_COMMUNITY_REPORT_CONTENT_TYPES: typeof BRANDED_COMMUNITY_REPORT_CONTENT_TYPES_TYPE =
    _BRANDED_COMMUNITY_REPORT_CONTENT_TYPES;

export const BRANDED_COMMUNITY_APIS: typeof BRANDED_COMMUNITY_APIS_TYPE =
    _BRANDED_COMMUNITY_APIS;

export const BRANDED_COMMUNITY_POST_CREATION_KEYS: typeof BRANDED_COMMUNITY_POST_CREATION_KEYS_TYPE =
    _BRANDED_COMMUNITY_POST_CREATION_KEYS;

export const CHANGE_STATES: typeof CHANGE_STATES_TYPE = _CHANGE_STATES;

export const POST_SHARING_TYPES: typeof POST_SHARING_TYPES_TYPE =
    _POST_SHARING_TYPES;

export const offering_tooltip_tittle = `All the offerings that are part of your community plan, will be available here.`;
export const feeds_tooltip_tittle = `All the feeds that are part of your community plan, will be available here.`;

export const TOOLTIPS = {
    SIDENAV:
        "You can easily navigate to anywhere within the community through this navigation panel.",
    SIDENAV_CTA: "You can reopen the navigation panel from here.",
};

export const default_branded_comm_theme_obj: IBrandedCommunity.ICommunityTheme =
    {
        colors: {
            primary: "",
            pageBackground: "",
            pageBodyText: "",
            headerBackground: "",
            primaryButtonText: "",
            color1: "",
            color2: "",
            color3: "",
            color4: "",
            color5: "",
        },
        font: {
            slug: "",
            title: "",
            url: "",
        },
    };

export const EXLY_COMMUNITY_FEED_TYPES: typeof EXLY_COMMUNITY_FEED_TYPES_TYPE =
    _EXLY_COMMUNITY_FEED_TYPES;

export const EXLY_COMMUNITY_CHANNEL_TYPES: typeof EXLY_COMMUNITY_CHANNEL_TYPES_TYPE =
    _EXLY_COMMUNITY_CHANNEL_TYPES;

export const DEFAULT_PROFILE_PIC =
    "https://exly-public-content.s3.ap-south-1.amazonaws.com/creator-tool/public/default_user_profile_image.png";

export const ONBOARDING_STEPS = {
    PROFILE: 0,
    MENU_CTA: 1,
    DEMO: 2,
};

export const ONBOARDING_START_DELAY = 500;
export const PROFILE_DESCRIPTION_MAX_CHARS = 250;

export const default_member_profile_modal_state = {
    open: false,
    memberUuid: "",
};

/**
 * @deprecated use this from repoV2/features/BrandedCommunity/BrandedCommunity.constants.ts
 */
export const COMMUNITY_URL_QUERY_PARAMS = _COMMUNITY_URL_QUERY_PARAMS;

/**
 * @deprecated use this from repoV2/features/BrandedCommunity/BrandedCommunity.constants.ts
 */
export const DEFAULT_SECTIONS = {
    FEED: 1,
    CHAT_WITH_CREATOR: 2,
    BONUS_OFFERINGS: 3,
    MEMBERS: 4,
};

export const redirection_types = {
    outside_community: 1,
    within_community: 2,
};

/**
 * TODO @mayank: use SIDEBAR_DEFAULT_SECTION_VISIBILITIES from `@my-scoot/exly-react-component-lib`
 */
export const default_section_visibilities = {
    default: 1,
    bottom_of_the_list: 2,
    hidden: 3,
};
